export default [
  {
    label: "Name",
    name: "name",
    type: "text",
    required: true,
  },
  {
    label: "Email",
    name: "email",
    type: "text",
    required: true,
  },
  {
    label: "UID",
    name: "uid",
    type: "text",
    required: true,
  },
  {
    label: "Status",
    name: "status",
    type: "select",
    options: ["Available", "Unavailable"],
  },
];
